import { Injectable } from '@angular/core';

/**
 * 共有データサービス.
 */
@Injectable()
export class SharedService {

  /** 共有データ. */
  private sharedData: { [key: string]: any } = {};

  /**
   * 指定したキーのデータを取得します.
   *
   * @param key キー
   */
  get<T>(key: string): T {
    return this.sharedData[key];
  }

  /**
   * 指定したキーにデータを格納します.
   *
   * @param key キー
   * @param value オブジェクト
   */
  set<T>(key: string, value: T) {
    this.sharedData[key] = value;
  }

  /**
   * 指定したキーのデータを削除します.
   *
   * @param key キー
   */
  remove(key: string) {
    delete this.sharedData[key];
  }
}



// WEBPACK FOOTER //
// ./src/app/common-app/service/shared.service.ts